<script>
import { reactive, toRefs, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { routeTo } from "@/utils";
import {
  addCompanyInfo,
  getCompanyInfo,
  updateCompanyInfo,
} from "@/api/modules/auth";
import SrUpload from "@/components/SrUpload";
import CertTypeSelect from "./components/cert-type-select";
import { commonUtils, vab } from "@libs/utils";
import { pinyin } from "pinyin-pro";
import { useI18n } from "@/plugins/i18n";

export default {
  components: { SrUpload, CertTypeSelect },
  setup() {
    const store = useStore();
    const { FILE } = store.state.base.constant;
    const _initForm = initForm();
    const { t, locale } = useI18n();
    const state = reactive({
      formRef: null,
      certRef: null,
      fileUrl: {

      },
      info: {
        certFileTip: t("auth.company.info.content.text_CN"),
      },
      COUNTRY_DESC_ENUM: {
        CN: t("auth.company.info.content.text_CN"),
        HK: t("auth.company.info.content.text_HK"),
        TW: t("auth.company.info.content.text_TW"),
        MO: t("auth.company.info.content.text_TW"),
        PK: t("auth.company.info.content.text_PK"),
        // SG: t("auth.company.info.content.text_7"),
        // US: t("auth.company.info.label.text_7"),
        // ID: t("auth.company.info.content.text_CN_1"),
        OTHER: t('auth.company.info.content.maxFileOther')
      },

      areaCountryList: store.state.base.dict.country.countryCodeList,
    });
    const COMP_FILE_ENUM = reactive({
      CN: {
        file_1: require("@/assets/img/components/sr-upload/ex/cn.jpg"),
        file_1_btn_desc: t("auth.company.info.content.upload2"),
        file_1_down_desc: t("auth.company.info.content.upload2"),
        file_1_require_desc: t("auth.company.info.error.upload"),

      },
      HK: {
        file_1: require("@/assets/img/components/sr-upload/ex/hk_br.jpg"),
        file_1_btn_desc: t("auth.company.info.content.uploadBR2"),
        file_1_down_desc: t("auth.company.info.content.uploadBR2"),
        file_1_require_desc: t("auth.company.info.error.uploadBR"),

        file_2: require("@/assets/img/components/sr-upload/ex/hk_ci.jpg"),
        file_2_btn_desc: t("auth.company.info.content.uploadCI2"),
        file_2_down_desc: t("auth.company.info.content.uploadCI2"),
        file_2_require_desc: t("auth.company.info.error.uploadCI"),
      },
      SG: {
        file_1: require("@/assets/img/components/sr-upload/ex/singapore.jpg"),
        file_1_btn_desc: t("auth.company.info.content.uploadACRA2"),
        file_1_down_desc: t("auth.company.info.content.uploadACRA2"),
        file_1_require_desc: t("auth.company.info.error.ACRA"),
      },
      GB: {
        file_1: require("@/assets/img/components/sr-upload/ex/england.jpg"),
        file_1_btn_desc: t("auth.company.info.content.uploadCert2"),
        file_1_down_desc: t("auth.company.info.content.uploadCert2"),
        file_1_require_desc: t("auth.company.info.error.otherCert"),
      },
      ID: {
        file_1: require("@/assets/img/components/sr-upload/ex/id-license.png"),
        file_1_btn_desc: t("auth.company.info.content.uploadNib2"),
        file_1_down_desc: t("auth.company.info.content.uploadNib2"),
        file_1_require_desc: t("auth.company.info.error.uploadNib"),
      },
      OTHER: {
        file_1: "",
        file_1_btn_desc: t("auth.company.info.content.uploadCert2"),
        file_1_down_desc: t("auth.company.info.content.uploadCert2"),
        file_1_require_desc: t("auth.company.info.error.otherCert"),
      }
    });

    const scopedMethods = {
      // 处理自动转化拼音
      handleToEname: (c) => {
        switch (c) {
          // case 'compEname':
          //   formReq.compEname = pinyin(formReq.compName, { toneType: 'none', type: 'array' }).join('')
          //   break
          case "compEAddr":
            _initForm.formReq.compEAddr = pinyin(
              _initForm.formReq.compAddr ? _initForm.formReq.compAddr : "",
              { toneType: "none", type: "array" }
            ).join("");
            break;
        }
      },
      // 上一步
      handlePrev: () => {
        routeTo("/auth/company/register");
      },
      checkCert: async (arr, index, res) => {
        console.log(arr, index, arr[index])
        if (arr.length != index) {
          let itemVal = await arr[index].validateForm();
          if (itemVal) {
            return scopedMethods.checkCert(arr, index + 1, true);
          } else {
            return false;
          }
        } else {
          return res;
        }
      },
      // 下一步
      handleNext: async () => {
        //  const certFlag = _initForm.certs.value.every(item => item.validateForm())

        let certFlag = await scopedMethods.checkCert(
          _initForm.certs.value,
          0,
          true
        );

        let certFlag2;
        if (_initForm.formReq.compRegRegion === "ID") {
          certFlag2 = await scopedMethods.checkCert(
            _initForm.certs2.value,
            0,
            true
          );
        }

        const stepComplete =
          store.state.auth.registerInfo?.stepComplete || null;
        const regType = store.state.auth.registerInfo?.regType || null;
        localStorage.removeItem("directorInfoTemp");
        localStorage.removeItem("directorInfoTemp2");

        state.formRef.validate(async (valid) => {
          if (valid && certFlag) {
            if (_initForm.formReq.compRegRegion === "ID" && !certFlag2) {
              return;
            }
            const directorInfoList = [];

            // 处理打包问题
            let cache = [];
            const temp = _initForm.certs.value
              .map((item, index) => ({ ...item.form, disabledSelect: true, countryCode: _initForm.formReq.directorInfoList[index]?.countryCode }))
              .filter((item) => item.holdInterval);
            const directorInfoTemp = JSON.stringify(temp, (key, value) => {
              if (typeof value === "object" && value !== null) {
                if (cache.indexOf(value) !== -1) return;
                cache.push(value);
              }
              return value;
            });
            cache = null;

            // 处理打包问题
            let cache2 = [];
            const temp2 = _initForm.certs2.value
              .map((item, index) => ({ ...item.form, disabledSelect: true, countryCode: _initForm.formReq.directorIDInfoList[index]?.countryCode }))
              .filter((item) => item.holdInterval);
            const directorInfoTemp2 = JSON.stringify(temp2, (key, value) => {
              if (typeof value === "object" && value !== null) {
                if (cache2.indexOf(value) !== -1) return;
                cache2.push(value);
              }
              return value;
            });
            cache2 = null;

            localStorage.setItem("directorInfoTemp", directorInfoTemp);
            localStorage.setItem("directorInfoTemp2", directorInfoTemp2);
            _initForm.loadingScope.btnLoading = true;
            const {
              compAddr,
              compBrFileId,
              compCiFileId,
              compEAddr,
              compEname,
              compId,
              compName,
              compRegRegion,
              regId,
            } = _initForm.formReq;

            const getListData = (item, countryCode) => {
              return {
                backFileId: item.form.backFileId,
                frontFileId: item.form.frontFileId,
                idType: item.form.certType,
                userType: item.form.userType,
                compUserId: item.form.compUserId,
                countryCode: countryCode,
              };
            };

            _initForm.certs.value.forEach((item, index) => {
              directorInfoList.push(getListData(item, _initForm.formReq.directorInfoList[index]?.countryCode));
            });

            if (compRegRegion === "ID") {
              _initForm.certs2.value.forEach((item, index) => {
                directorInfoList.push(getListData(item, _initForm.formReq.directorIDInfoList[index]?.countryCode));
              });
            }

            const param = {
              directorInfoList,
              compAddr,
              compBrFileId,
              compCiFileId,
              compEAddr,
              compEname,
              compId,
              compName,
              compRegRegion,
              regId: store.state.auth.regId,
              userId: store.state.user.userId,
            };

            try {
              regId
                ? await updateCompanyInfo({ ...param, regId })
                : await addCompanyInfo(param);
              _initForm.loadingScope.btnLoading = false;
              routeTo(
                (+stepComplete === 1 ||
                  scopedComputed.nextOrUpdate.value === "update") &&
                  +regType !== 1
                  ? "/auth/company/overview"
                  : "/auth/company/shareholder"
              );
            } catch (err) {
              _initForm.loadingScope.btnLoading = false;
              console.log(err);
            }
          }
        });
      },
    };
    const scopedComputed = {
      nextOrUpdate: computed(() =>
        +store.state.auth.step !== 4 ? "next" : "update"
      ),
      countryDesc: computed(() => {
        return COMP_FILE_ENUM?.[_initForm.formReq.compRegRegion] || COMP_FILE_ENUM.OTHER
      })
    };

    watch(
      () => _initForm.formReq.compRegRegion,
      (value) => {
        state.info.certFileTip = state.COUNTRY_DESC_ENUM[value] || state.COUNTRY_DESC_ENUM.OTHER

        if (value === "CN" || value === "TW") {
          _initForm.formReq.directorInfoList =
            _initForm.formReq.directorInfoList.slice(0, 1);
          _initForm.certs.value = _initForm.certs.value.slice(0, 1);
          _initForm.certs2.value = _initForm.certs2.value.slice(0, 1);
        }

        state?.formRef?.clearValidate(["compBrFileId", "compCiFileId"]);
      }
    );

    return {
      ...toRefs(state),
      COMP_FILE_ENUM,
      ...toRefs(_initForm),
      ...scopedMethods,
      ...scopedComputed,
      FILE,
      t,
      store
    };
  },
};

// 初始化form
const initForm = () => {
  const store = useStore();
  const { t } = useI18n();
  const formReq = reactive({
    directorInfoList: [
      {
        identity: "1",
        sync: false,
        countryCode: "",
        certScope: {
          holdInterval: false,
          certType: "I",
          userType: "L",
          frontFileId: "",
          frontFileName: "",
          compUserId: null,
          backFileId: "",
          backFileName: "",
        },
      },
    ],
    directorIDInfoList: [
      {
        identity: "1",
        sync: false,
        countryCode: "",
        certScope: {
          holdInterval: false,
          certType: "I",
          userType: "C",
          frontFileId: "",
          frontFileName: "",
          compUserId: null,
          backFileId: "",
          backFileName: "",
        },
      },
    ],
    compAddr: "",
    compBrFileId: "",
    compBrFileName: "",
    compCiFileId: "",
    compCiFileName: "",
    compEAddr: "",
    compEname: "",
    compId: "",
    compName: "",
    compRegRegion: "CN",
    regId: "",
    userId: "",
  });

  const certs = ref([]);
  const certs2 = ref([]);

  // 添加股东
  const handleAddDirector = () => {
    formReq.directorInfoList.push({
      identity: "1",
      sync: false,
      countryCode: "",
      certScope: {
        holdInterval: false,
        certType: "I",
        userType: "L",
        frontFileId: "",
        frontFileName: "",
        compUserId: null,
        backFileId: "",
        backFileName: "",
      },
    });
  };
  // 添加监事
  const handleAddIDDirector = () => {
    formReq.directorIDInfoList.push({
      identity: "1",
      sync: false,
      countryCode: "",
      certScope: {
        holdInterval: false,
        certType: "I",
        userType: "C",
        frontFileId: "",
        frontFileName: "",
        compUserId: null,
        backFileId: "",
        backFileName: "",
      },
    });
  };


  // 删除股东
  const handleDelDirector = (i) => {
    if (
      formReq.directorInfoList[i].userCheckStatus &&
      !["RJ", "ST", "WC"].includes(formReq.directorInfoList[i].userCheckStatus)
    )
      return vab.baseMessage("审核已通过项无法删除", "error");

    formReq.directorInfoList.splice(i, 1);
    certs.value.splice(i, 1);
  };
  // 删除监事
  const handleDelIDDirector = (i) => {
    if (
      formReq.directorIDInfoList[i].userCheckStatus &&
      !["RJ", "ST", "WC"].includes(
        formReq.directorIDInfoList[i].userCheckStatus
      )
    )
      return vab.baseMessage("审核已通过项无法删除", "error");
    formReq.directorIDInfoList.splice(i, 1);
    certs2.value.splice(i, 1);
  };

  const loadingScope = reactive({
    pageLoading: false,
    btnLoading: false,
  });
  const validateEnText = (rule, value, callback) => {
    // [\x00-\xff] 代表 0 - 255的 ASCII 码值，是单字节的，非就是大于255的ASCII码，是双字节的
    const reg = /[^\x00-\xff]/g;
    if (reg.test(value)) {
      callback(new Error(t("auth.company.info.error.text_1")));
    } else {
      callback();
    }
  };

  const validateEnName = (rule, value, callback) => {
    if (!value) {
      callback(
        new Error(
          rule.field === "compEname"
            ? t("auth.company.info.placeholder.text_2")
            : t("auth.company.info.placeholder.text_6")
        )
      );
    } else {
      validateEnText(rule, value, callback);
    }
  };

  const rules = reactive({
    compName: [
      {
        required: true,
        message: t("auth.company.info.placeholder.text_1"),
        trigger: "blur",
      },
      {
        max: 128,
        message: t("auth.company.info.error.maxLength128"),
        trigger: "blur",
      },
    ],
    compEname: [
      { 
        required: true, 
        validator: validateEnName, 
        trigger: "blur" 
      },
      {
        max: 128,
        message: t("auth.company.info.error.maxLength128"),
        trigger: "blur",
      },
    ],
    compRegRegion: [
      {
        required: true,
        message: t("auth.company.info.placeholder.text_4"),
        trigger: "change",
      },
    ],
    compAddr: [
      {
        required: true,
        message: t("auth.company.info.placeholder.text_5"),
        trigger: "blur",
      },
    ],
    compEAddr: [{ required: true, validator: validateEnName, trigger: "blur" }],
    regCertFileId: [
      {
        required: true,
        message: t("auth.company.info.error.text_5"),
        trigger: "change",
      },
    ],
  });

  const initData = async () => {
    loadingScope.pageLoading = true;
    try {
      const res = await getCompanyInfo();
      store.dispatch("auth/setStep");
      if (res.regId) {
        let directorInfoList = [];
        let directorIDInfoList = [];

        if (res.directorInfoList && res.directorInfoList?.length > 0) {
          res.directorInfoList.forEach((item) => {
            let obj = {
              ...item,
              countryCode: item.countryCode || "",
              certScope: {
                certType: item.idType,
                userType: item.userType,
                frontFileId: item.frontFileId,
                compUserId: item.compUserId,
                userCheckStatus: item.userCheckStatus,
                frontFileName: "",
                backFileId: item.backFileId,
                backFileName: "",
                holdInterval: false,
              },
            };
            if (item.userType !== "C") {
              directorInfoList.push(obj);
            } else {
              directorIDInfoList.push(obj);
            }
          });

          formReq.directorInfoList = directorInfoList;
          formReq.directorIDInfoList = directorIDInfoList;
        } else {
          formReq.directorInfoList = [
            {
              identity: "1",
              sync: false,
              countryCode: "",
              certScope: {
                holdInterval: false,
                certType: "I",
                userType: "L",
                frontFileId: "",
                compUserId: null,
                frontFileName: "",
                backFileId: "",
                backFileName: "",
              },
            },
          ];
          formReq.directorIDInfoList = [
            {
              identity: "1",
              sync: false,
              countryCode: "",
              certScope: {
                holdInterval: false,
                certType: "I",
                userType: "C",
                frontFileId: "",
                compUserId: null,
                frontFileName: "",
                backFileId: "",
                backFileName: "",
              },
            },
          ];
        }

        formReq.compAddr = res.compAddr;
        formReq.compBrFileId = res.compBrFileId;
        formReq.compBrFileName = res.compBrFileName;
        formReq.compCiFileId = res.compCiFileId;
        formReq.compCiFileName = res.compCiFileName;
        formReq.compEAddr = res.compEAddr;
        formReq.compEname = res.compEname;
        formReq.compId = res.compId;
        formReq.compName = res.compName;
        formReq.compRegRegion = res.compRegRegion;
        formReq.regId = res.regId;
        formReq.compCheckStatus = res.compCheckStatus;
      }
      loadingScope.pageLoading = false;
    } catch {
      loadingScope.pageLoading = false;
    }
  };

  initData();

  return {
    formReq,
    loadingScope,
    certs,
    certs2,
    rules,
    handleAddDirector,
    handleDelDirector,
    handleAddIDDirector,
    handleDelIDDirector,
  };
};
</script>



<template>
  <div>
    <div class="auth-info-container">
      <el-form :model="formReq" :rules="rules" ref="formRef" :label-width="localCN ? '150px' : '230px'"
        label-position="left" v-loading="pageLoading">
        <el-row>
          <el-col :span="24">
            <div class="h1">{{ t('auth.company.info.title.text_1') }}</div>
            <el-form-item prop="compName" :label="t('auth.company.info.label.text_1')">
              <el-input v-model="formReq.compName" :placeholder="t('auth.company.info.placeholder.text_1')"
                :disabled="formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)" />
              <!-- <span class="h3"
                style="margin-left: 12px;">{{t('auth.company.info.content.text_2')}}</span> -->
            </el-form-item>

            <el-form-item prop="compEname" :label="t('auth.company.info.label.text_2')">
              <el-input v-model="formReq.compEname" @focus="handleToEname('compEname')"
                :placeholder="t('auth.company.info.placeholder.text_2')"
                :disabled="formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)" />
              <span class="h3" style="margin-left: 12px;">{{ t('auth.company.info.content.text_3') }}</span>
            </el-form-item>

            <el-form-item prop="compRegRegion" :label="t('auth.company.info.label.text_3')">
              <el-select :disabled="formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)"
                v-model="formReq.compRegRegion" @change="handleRegionChange" filterable>
                <el-option v-for="country in areaCountryList" :key="country.value" :label="country.label"
                  :value="country.value">
                </el-option>
              </el-select>

            </el-form-item>

            <el-form-item prop="compAddr" :label="t('auth.company.info.label.text_4')">
              <el-input v-model="formReq.compAddr" :type="localCN ? 'input' : 'textarea'" autosize
                :placeholder="t('auth.company.info.placeholder.text_3')"
                :disabled="formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)" />
            </el-form-item>

            <el-form-item prop="compEAddr" :label="t('auth.company.info.label.text_5')">
              <el-input v-model="formReq.compEAddr" :type="localCN ? 'input' : 'textarea'" autosize
                @focus="handleToEname('compEAddr')" :placeholder="t('auth.company.info.placeholder.text_3')"
                :disabled="formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)" />
            </el-form-item>

            <div>
              <el-form-item :label="t('auth.company.info.label.text_7')" :rules="{ required: true }">
                <div class="auth-upload-container">
                  <div class="upload-title-wrap">
                    <div class="h2" style="padding-top:10px">
                      {{ info.certFileTip }}{{ t('auth.company.info.content.text_8') }}
                      <!-- <span v-if="(['CN','HK','SG','GB','ID'].includes(formReq.compRegRegion))">
                        {{t('auth.company.info.content.text_8_1')}}
                        <a class="a"
                          style="color: #333;"
                          href="javascript: void(0);"> {{t('auth.company.info.content.text_21_2')}}</a></span> -->
                    </div>
                  </div>
                  <div class="auth-upload-wrap">
                    <div class="auth-upload-item">
                      <el-form-item class="upload-item" prop="compBrFileId"
                        :rules="{ required: true, message: countryDesc.file_1_require_desc, trigger: 'change' }">
                        <sr-upload v-model:fileId="formReq.compBrFileId" v-model:fileName="formReq.compBrFileName"
                        longSize=true
                          :filePrefix="FILE.PREFIX.FRONT_FILE" fileSize="5"
                          :uploadDesc="countryDesc.file_1_btn_desc || '-'" :fileExample="countryDesc.file_1"
                          :mode="(formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)) ? FILE.UPLOAD_MODE.READONLY : FILE.UPLOAD_MODE.EDITABLE" />
                      </el-form-item>
                      <div class="h3">{{ countryDesc.file_1_down_desc || '-' }}</div>
                    </div>
                    <div class="auth-upload-item" v-if="formReq.compRegRegion === 'HK'">
                      <el-form-item class="upload-item" prop="compCiFileId"
                        :rules="{ required: true, message: countryDesc.file_2_require_desc, trigger: 'change' }">
                        <sr-upload v-model:fileId="formReq.compCiFileId" v-model:fileName="formReq.compCiFileName"
                        longSize=true
                          :filePrefix="FILE.PREFIX.BACK_FILE" fileSize="5"
                          :uploadDesc="countryDesc.file_2_btn_desc || '-'" :fileExample="countryDesc.file_2"
                          :mode="(formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)) ? FILE.UPLOAD_MODE.READONLY : FILE.UPLOAD_MODE.EDITABLE" />
                      </el-form-item>
                      <div class="h3">{{ countryDesc.file_2_down_desc || '-' }}</div>
                    </div>
                    <!-- 实益人 -->
                    <div class="auth-upload-item" v-if="!['CN','TW','MO','HK'].includes(formReq.compRegRegion)">
                      <el-form-item class="upload-item" prop="compCiFileId"
                        :rules="{ required: true, message: t('auth.company.info.content.uploadCO'), trigger: 'change' }">
                        <sr-upload v-model:fileId="formReq.compCiFileId" v-model:fileName="formReq.compCiFileName"
                          :filePrefix="FILE.PREFIX.BACK_FILE" fileSize="5"
                          longSize=true
                          :uploadDesc="t('auth.company.info.content.uploadCO')"
                          :mode="(formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)) ? FILE.UPLOAD_MODE.READONLY : FILE.UPLOAD_MODE.EDITABLE" />
                      </el-form-item>
                      <div class="h3">{{ t("auth.company.info.content.uploadCO") }}</div>
                    </div>

                  </div>
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div v-for="(item, index) in formReq.directorInfoList" :key="index">
              <p class="auth-title auth-person__subtract">
                <span
                  v-if="formReq.compRegRegion === 'CN' || formReq.compRegRegion === 'TW'">{{ t('auth.company.info.content.text_14') }}<span v-if="formReq.directorInfoList.length>1">{{index + 1 }}</span></span>
                <span v-else>{{ t('auth.company.info.content.text_1') }}<span v-if="formReq.directorInfoList.length>1">{{index + 1 }}</span></span>
                <el-button
                  v-if="(formReq.compRegRegion === 'ID' ? (formReq.directorInfoList.length > 1) : formReq.directorInfoList.length > 1) && !item.sync"
                  type="danger" size="mini"
                  @click="handleDelDirector(index)">{{ t('auth.company.info.content.text_18') }}</el-button>
              </p>

              <div>
                <!--证件签发地-->
                <el-form-item :prop="'directorInfoList.' + index + '.countryCode'"
                  :rules="{ required: true, message: t('auth.company.register.error.issuingCountry'), trigger: 'change' }"
                  :placeholder="t('auth.company.register.error.issuingCountry2')"
                  :label="t('auth.company.register.label.issuingCountry')">
                  <el-select v-model="item.countryCode" filterable>
                    <el-option v-for="country in areaCountryList" :key="country.value" :label="country.label"
                      :value="country.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <cert-type-select :ref="el => { if (el) certs[index] = el }" :scopeData="item.certScope"
                  :compRegRegion="item.countryCode" />
              </div>

              <el-form-item>
                <div class="auth-line"></div>
              </el-form-item>
            </div>
            <div class="auth-item-box" style="margin-top: 32px;"
              v-if="formReq.compRegRegion !== 'CN' && formReq.compRegRegion !== 'TW'">
              <div class="auth-person__add">

                <span @click="handleAddDirector">+{{ t('auth.company.info.content.text_13') }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="24" v-if="formReq.compRegRegion === 'ID'">
            <div v-for="(item, index) in formReq.directorIDInfoList" :key="index">
              <p class="auth-title auth-person__subtract">
                <span
                  v-if="formReq.compRegRegion === 'CN' || formReq.compRegRegion === 'TW'">{{ t('auth.company.info.content.text_14') }}<span v-if="formReq.directorIDInfoList.length>1">{{index + 1 }}</span></span>
                <span v-else-if="formReq.compRegRegion === 'ID'">{{ t('auth.company.info.content.text_22') }}<span v-if="formReq.directorIDInfoList.length>1">{{index + 1 }}</span></span>
                <span v-else>{{ t('auth.company.info.content.text_1') }}<span v-if="formReq.directorIDInfoList.length>1">{{index + 1 }}</span></span>
                <el-button
                  v-if="(formReq.compRegRegion === 'ID' ? (formReq.directorIDInfoList.length > 1) : formReq.directorInfoList.length > 1) && !item.sync"
                  type="danger" size="mini"
                  @click="handleDelIDDirector(index)">{{ t('auth.company.info.content.text_18') }}</el-button>
              </p>

              <div>
                <!--证件签发地-->
                <el-form-item :prop="'directorIDInfoList.' + index + '.countryCode'"
                  :rules="{ required: true, message: t('auth.company.register.error.issuingCountry'), trigger: 'change' }"
                  :placeholder="t('auth.company.register.error.issuingCountry2')"
                  :label="t('auth.company.register.label.issuingCountry')">
                  <el-select v-model="item.countryCode" filterable>
                    <el-option v-for="country in areaCountryList" :key="country.value" :label="country.label"
                      :value="country.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <cert-type-select :ref="el => { if (el) certs2[index] = el }" :scopeData="item.certScope"
                  :compRegRegion="item.countryCode" />
              </div>

              <el-form-item>
                <div class="auth-line"></div>
              </el-form-item>
            </div>
            <div class="auth-item-box" style="margin-top: 32px;"
              v-if="formReq.compRegRegion !== 'CN' && formReq.compRegRegion !== 'TW'">
              <div class="auth-person__add">
                <span @click="handleAddIDDirector">+{{ t('auth.company.info.content.text_13_2') }}</span>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item>
              <el-button class="el-button__prev" v-if="store.state.auth.step != 4" @click="handlePrev"
                :disabled="formReq.compCheckStatus && ['CF', 'CP'].includes(formReq.compCheckStatus)">{{ t('auth.company.business.content.text_5') }}</el-button>
              <el-button class="el-button__next" type="primary" v-loading="btnLoading"
                @click="handleNext">{{ t('auth.company.business.content.text_4') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.auth-info-container {
  padding: 20px;
  background-color: #fff;

  .auth-upload-container {
    width: 100%;
    box-sizing: border-box;

    .auth-upload-wrap {
      width: 100%;
      display: flex;

      .auth-upload-item {
        margin-right: 60px;

        .upload-item {
          margin-bottom: 15px;
        }
      }
    }
  }

  // 分割线
  .auth-line {
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  // 勾选部分
  .auth-check {
    margin-bottom: 40px;
  }

  // 新增 ex：新增董事、新增股东
  .auth-person__add {
    width: 100%;
    height: 64px;
    margin-top: 22px;
    margin-bottom: 52px;
    background-color: #f9f9f9;
    border: 1px dashed #e2e2e2;
    border-radius: 4px;
    text-align: center;
    line-height: 64px;

    span {
      color: #409eff;
      cursor: pointer;
    }
  }

  // 删除
  .auth-person__subtract {
    .el-button {
      width: 74px;
      height: 34px;
      margin-right: 130px;
      background: #ffeeee;
      border: none;
      border-radius: 3px !important;
      color: #ff4040;
      float: right;
    }
  }
}

:deep(.el-form-item__content) {
  flex: inherit !important;
  width: auto !important;

  .el-input__inner,
  .el-textarea__inner {
    width: 360px !important;
    border-radius: 4px !important;
  }

  .el-select {

    .el-input__inner,
    .el-textarea__inner {
      width: 340px !important;
      border-radius: 4px !important;
    }
  }

  .el-textarea {

    .el-input__inner,
    .el-textarea__inner {
      width: 390px !important;
      border-radius: 4px !important;
    }
  }

  .el-input {
    width: auto;
  }
}
</style>
